import Modal from "components/common/controls/modal/Modal";
import ProductLicense from "interfaces/response/ProductLicense";
import SubscriptionChangePreviewResponse from "interfaces/response/SubscriptionChangePreviewResponse";
import SubscriptionConfirmation from "./SubscriptionConfirmation";
import CancelSubscriptionConfirmation from "./CancelSubscriptionConfirmation";

interface Props {
  onClose?: () => void;
  onSubscriptionChangeConfirm?: (
    previewData: SubscriptionChangePreviewResponse | null
  ) => void;
  isCancel?: boolean;
  onSubscriptionCancelConfirm?: () => void;
  defaultFreeLicense?: ProductLicense;
}

export default function SunscriptionConfirmationPopup(props: Props) {
  const {
    isCancel,
    defaultFreeLicense,
    onClose,
    onSubscriptionChangeConfirm,
    onSubscriptionCancelConfirm,
  } = props;

  return (
    <>
      <Modal
        visible={true}
        onClose={onClose}
        width="471px"
        height="auto"
        displayDefaultActions={false}
      >
        {!isCancel ? (
          <SubscriptionConfirmation
            onApply={onSubscriptionChangeConfirm}
            onCancel={onClose}
          />
        ) : (
          defaultFreeLicense && (
            <CancelSubscriptionConfirmation
              defaultFreeLicense={defaultFreeLicense}
              onApply={onSubscriptionCancelConfirm}
              onCancel={onClose}
            />
          )
        )}
      </Modal>
    </>
  );
}
